import React from 'react';
import { Edit, SimpleForm, Toolbar, TopToolbar, NumberInput, useNotify, useRefresh, SelectInput, TextField, RefreshButton, ListButton, SaveButton, ShowButton } from 'react-admin';
import { useGetOne } from 'react-admin';


const EditActions = ({ basePath, data }) => {
    console.log('basePath', basePath);
    return (
        <TopToolbar>
            <RefreshButton />
            {
                data &&
                <ListButton basePath={`/sap_digital_orders/${data.sap_digital_order_id}/show/1`} />
            }
        </TopToolbar>
    )
}

const EditButtons = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);


const DigitalOrdersLineItemEdit = ({ permissions, ...props }) => {
    const notify = useNotify();
    const refresh = useRefresh();

    const { data } = useGetOne({
        // type: 'getList',
        resource: `get_products_list?line_item_id=${props.id}`,
        payload: { id: 1 }
    });
    const productChoices = data;

    const ProductList = ({ record = {}, source }) => {
        return (
            <SelectInput source="material_id" choices={productChoices}
                optionText="description" optionValue="id"
                defaultValue={record.products_master_id}
            />
        )
    }

    const Quantity = ({ record = {}, source }) => (
        <NumberInput source="quantity" min="0.1" label={`Qunatity (${record.product_master.input_uom_name})`} />
    )

    const onSuccess = ({ data }) => {
        notify(`Changes to line items "${data.product_master.description}" saved`)
        props.history.goBack()
        refresh();
    };

    return (
        <Edit onSuccess={onSuccess} undoable={false} {...props} title="Line Item Edit" actions={<EditActions />}>
            <SimpleForm toolbar={<EditButtons />}>
                <ProductList source="material_id" label="Products" />
                <Quantity source="quantity" />                
            </SimpleForm>
        </Edit>
    )
}

export default DigitalOrdersLineItemEdit;